import { ref, type Ref } from 'vue-demi';
import type { PredictApiClient } from '../../shared/api';
import type { SubmitGuessResponse } from '@ark/predict-shared';

export interface UseSubmitGuessOptions {
  apiClient: PredictApiClient;
}

export interface UseSubmitGuessReturn {
  submitting: Ref<boolean>;
  lastResult: Ref<SubmitGuessResponse | null>;
  error: Ref<string>;
  submit: (
    marketId: string,
    answerValue: string,
    reason?: {
      presetCode?: string;
      customText?: string;
      label?: Record<string, string>;
    },
  ) => Promise<boolean>;
}

export function useSubmitGuess(
  options: UseSubmitGuessOptions,
): UseSubmitGuessReturn {
  const submitting = ref(false);
  const lastResult = ref<SubmitGuessResponse | null>(null);
  const error = ref('');

  async function submit(
    marketId: string,
    answerValue: string,
    reason?: {
      presetCode?: string;
      customText?: string;
      label?: Record<string, string>;
    },
  ): Promise<boolean> {
    submitting.value = true;
    error.value = '';
    try {
      lastResult.value = await options.apiClient.submitGuess(
        marketId,
        answerValue,
        reason,
      );
      return true;
    } catch (err) {
      error.value = err instanceof Error ? err.message : '提交失败';
      return false;
    } finally {
      submitting.value = false;
    }
  }

  return { submitting, lastResult, error, submit };
}
